import React from 'react'
import PropTypes from 'prop-types'

const PageHeading = ({ title, imgUrl, alt }) => {
    return (
        <>
            <div className='bg-primary-blue w-full h-96 relative mb-32'>
                <img src={imgUrl} alt={alt} className='w-full h-96 object-cover' />
                <h2 className='text-white uppercase bg-primary-blue text-6xl font-bebas absolute drop-shadow-lg -bottom-16 p-10 left-1/2 -translate-x-1/2 md:-translate-x-0 md:left-20 lg:left-72 lg:-translate-x-60 xl:left-96 xl:-translate-x-44 transform text-center md:text-start'>{title}</h2>
            </div>
        </>
    )
}

PageHeading.propTypes = {
    title: PropTypes.string.isRequired,
    imgUrl: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
}

export default PageHeading